var HotelModals = (function (window, $j) {

    function onDocReady() {
        registerModalButtons();
        registerModals();

        registerGalleryButtons();
    }

    function registerModalButtons() {
        $j(".modal-open-button").click(function () {
            $j(this).closest(".hotel-item").find(".meeting-modal").addClass("modal-open");
        });
    }

    function registerModals() {
        $j(".modal-overlay").click(function () {
            $j(this).closest(".meeting-modal").removeClass("modal-open");
        });
    }

    function resetGalleryControls () {
        $j(".real-meeting-modal .nav-item.next-item").removeClass('disabled');
        $j(".real-meeting-modal .nav-item.prev-item").addClass('disabled');
    }

    function registerGalleryButtons() {
        $j(".launch-gallery-button").click(function () {
            resetGalleryControls();

            var container = $j(this).closest(".real-meeting-item");

            container.find(".meeting-modal").addClass("modal-open");

            // Disable next if no slides
            var slideCount = container.find(".media-item");
            if (slideCount.length < 2) {
                $j(".real-meeting-modal .nav-item.next-item").addClass('disabled');
            }

            // Reset active to first slide to prvent conflicts with other slideshows
            container.find(".media-item.active").removeClass('active');
            container.find(".media-item").eq(0).addClass('active');
        });

        $j(".real-meeting-modal .nav-item.next-item").click(function () {
            var container = $j(this).closest(".real-meeting-modal").find(".gallery-modal-container");

            var targetMediaItem = container.find(".media-item.active");
            var targetCaption = container.find(".caption-container p.active");

            if (targetMediaItem.index() < container.find(".media-item").length - 1) {
                $j(".real-meeting-modal .nav-item.prev-item").removeClass("disabled");
                targetMediaItem.next().addClass("active");
                targetCaption.next().addClass("active");
                targetMediaItem.removeClass("active");
                targetCaption.removeClass("active");
            }

            if (targetMediaItem.index() === container.find(".media-item").length - 2) {
                $j(".real-meeting-modal .nav-item.next-item").addClass("disabled");
            }
        });

        $j(".real-meeting-modal .nav-item.prev-item").click(function () {
            var container = $j(this).closest(".real-meeting-modal").find(".gallery-modal-container");
            var targetMediaItem = container.find(".media-item.active");
            var targetCaption = container.find(".caption-container p.active");

            if (targetMediaItem.index() > 0) {
                $j(".real-meeting-modal .nav-item.next-item").removeClass("disabled");
                targetMediaItem.prev().addClass("active");
                targetCaption.prev().addClass("active");
                targetMediaItem.removeClass("active");
                targetCaption.removeClass("active");
            }
            if (targetMediaItem.index() === 1) {
                $j(".real-meeting-modal .nav-item.prev-item").addClass("disabled");
            }
        });
    }

    $j(onDocReady);

    return {
        registerModalButtons: registerModalButtons,
        registerModals: registerModals
    };

})(window, $j);